import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  message,
  Select,
  Upload,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { UploadOutlined } from "@ant-design/icons";

function UpdateProductModal(props) {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const { visible, close, selectedRecord } = props;

  const [editResponse, editRequest] = useApi(
    `/config/product/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true // multipart form data
  );

  const [categoryResponse, categoryRequest] = useApi(
    "/config/category/dropdown",
    null,
    API_METHODS.GET
  );

  const [subcategoryResponse, subcategoryRequest] = useApi(
    "/config/subcategory/category/",
    null,
    API_METHODS.GET
  );

  const [categories, setcategories] = useState([]);
  const [subcategories, setsubcategories] = useState([]);

  useEffect(() => {
    categoryRequest();
  }, []);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Product updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      // Set form values based on selected record
      form.setFieldsValue({
        price: selectedRecord.price,
        category_id: selectedRecord.category_id,
        subcategory_id: selectedRecord.subcategory_id,
      });

      // Load subcategories for the selected category
      if (selectedRecord.category_id) {
        subcategoryRequest(
          null,
          API_METHODS.GET,
          `/config/subcategory/category/${selectedRecord.category_id}`
        );
      }
    }
  }, [selectedRecord]);

  useEffect(() => {
    const data =
      categoryResponse.data !== BLANK_VALUE ? categoryResponse.data : [];
    setcategories(data);
  }, [categoryResponse]);

  useEffect(() => {
    const data =
      subcategoryResponse.data !== BLANK_VALUE ? subcategoryResponse.data : [];
    setsubcategories(data);
  }, [subcategoryResponse]);

  const categoryChanged = (category_id) => {
    form.setFieldValue("subcategory_id", null);
    subcategoryRequest(
      null,
      API_METHODS.GET,
      `/config/subcategory/category/${category_id}`
    );
  };

  const uploadProps = {
    multiple: true,
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        formData.append("price", values.price);
        formData.append("category_id", values.category_id);
        formData.append("subcategory_id", values.subcategory_id);

        // Add file uploads
        if (values["file"]) {
          formData.append(
            "file",
            values["file"].file.originFileObj,
            values["file"].file.name
          );
        }

        if (values["video"]) {
          formData.append(
            "video",
            values["video"].file.originFileObj,
            values["video"].file.name
          );
        }

        if (values.photos && values.photos.fileList) {
          for (const photo of values.photos.fileList) {
            formData.append("photos", photo.originFileObj, photo.name);
          }
        }

        editRequest(formData);
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title="Update Product"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1200}
      okText="Update Product"
      confirmLoading={editResponse.isLoading}
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="file"
              label="Product File"
              rules={[{ required: true, message: "Product File is required." }]}
            >
              <Upload customRequest={dummyRequest} maxCount={1}>
                <Button icon={<UploadOutlined />}>Upload Product</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="price"
              label="Price"
              rules={[{ required: true, message: "Price is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="category_id"
              label="Category"
              rules={[{ required: true, message: "Category is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onChange={categoryChanged}
              >
                {categories?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {subcategories?.length > 0 && (
            <Col span={8}>
              <Form.Item
                name="subcategory_id"
                label="Subcategory"
                rules={[
                  { required: true, message: "Subcategory is required." },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {subcategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.subcategory}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item
              name="photos"
              label="Product Photos"
              rules={[
                { required: true, message: "Product Photos is required." },
              ]}
            >
              <Upload
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={6}
              >
                <Button icon={<UploadOutlined />}>
                  Click to Upload Photos
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="video" label="Product Video">
              <Upload customRequest={dummyRequest} maxCount={1}>
                <Button icon={<UploadOutlined />}>Click to Upload Video</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default UpdateProductModal;
